<template>
  <div>
    <b-modal
      id="modal-add-revenue-fast"
      v-model="isOpen"
      centered
      size="lg"
      hide-header
      :no-close-on-backdrop="true"
    >
      <b-card-header class="banned-background-color-primary">
        <div class="d-flex justify-content-between align-items-center block-header">
          <p class="mb-0 title-modal color-primary">
            {{ $t('golf_revenue_fast_update_account') }}
          </p>
          <div>
            <b-button class="mr-2" variant="primary" @click ="AddRevenueFast()" >
                  <span >{{$t('golf_common_add_new')}}</span>
                     
          </b-button>
            <feather-icon
            icon="XIcon"
            size="24"
            class="cursor-pointer color-primary"
            @click="hideModal"
          />
         
          </div>
         
        </div>
      </b-card-header>
      <b-overlay :show="isLoading" :opacity="0.3" rounded="sm">
        <b-card-body style="height: 450px; overflow-y: auto;">
        <b-row>
          <b-col 
          md="3"
          class="block"
          >
          <p >
              {{ $t('golf_revenue_fast_account_code') }}
            </p>
          </b-col>
          <b-col
              md="3"
              class="block"
            >
            <p >
              {{ $t('golf_revenue_fast_account_value') }}
            </p>
          </b-col>
          <b-col
              md="5"
              class="block"
            >
            <p>
              {{ $t('golf_revenue_fast_desciption') }}
            </p>
          </b-col>
        </b-row>
        <b-row
          v-for="(item ,indexItem) in items" 
          :key="indexItem + 'item'"
          class="checkin-body mt-1"
        >
         
        <b-col
              md="3"
              class="block"
            >
            
              <b-form-input class="mb-1"
                :placeholder="$t('golf_revenue_fast_account_code')"
                v-model="item.AccountCode"
                ref="accountCodeInput"
              />
            </b-col>
            <b-col
              md="3"
              class="block"
            >
           
              <b-form-input 
                :placeholder="$t('golf_revenue_fast_account_value')"
                v-model="item.AccountValue"
                ref="accountValueInput"
               
              />
            </b-col>
            <b-col
              md="5"
              class="block"
            >
              <b-form-input 
                :placeholder="$t('golf_revenue_fast_desciption')"
                v-model="item.Description"
              />
            </b-col>
            <b-col md="1">
              <div class="d-flex justify-content-center align-items-center">
                <ez-icon
                              icon="ezGolf-icon-trash"
                              size="18"
                              color="#EA5455"
                              class="cursor-pointer"
                              @click ="DeleteRevenueFast(indexItem)"
                              />
              </div>
            </b-col>

        </b-row>
      </b-card-body>
      </b-overlay>
      
      <template #modal-footer>
        <div class="w-100">
          <b-button
            variant="outline-secondary"
            size="md"
            class="float-right"
            :disabled="isLoading"
            @click="hideModal"
          >
          {{ $t('golf_common_back') }}
          </b-button>
          <b-button
            v-b-tooltip.hover
            title="Ctrl + S"
            variant="primary"
            size="md"
            class="float-right mr-1"
            :disabled="isLoading"
            @click="save"
          >
          {{ $t('golf_common_confirm') }}
          </b-button>
        </div>
      </template>
    </b-modal>
    <ShortKey
      :shortcuts="ShortCutKey"
      :isActive="isOpen"
      :allChildComponentClosed="allChildComponentClosed"
      @triggered="onTriggeredEventHandler"
    />
  </div>
</template>

<script>
import jquery from 'jquery'
import { booking } from '@/api/booking'
import { reportSetting } from '@/api/Report-Setting'
import UserAvatar from '@/views/modules/booking/UserAvatar'
import {F1,F2,F3,F4,F5,F6,F7,F8,F9,F10,F11,F12,A,F,S} from '@/api/constant.js'
import ShortKey from '@/views/modules/ultils/ShortKey'
import { members } from '@/api/members'
export default {
  components: { UserAvatar, ShortKey },
  props:['listRevenueFast','revenueCenterId'],
  data() {
    return {
      isOpen: false,
      ShortCutKey : [F1,F2,F3,F4,F5,F6,F7,F8,F9,F10,F11,F12,A,F,S],
      allChildComponentClosed: [],
      inputForcus: false,
      isCheckAll: false,
      iTab: 1,
      isLoading: false,
      items:[],
    }
  },
  watch: {
    isOpen(val) {
      if(val) {
        this.items = [...this.listRevenueFast]
      
        if(this.items.length ==0){
          this.AddRevenueFast()
        }
      }
      //this.inputForcus = true
    }
  },
  methods: {
    hideModal() {
      this.$bvModal.hide('modal-add-revenue-fast')
    },
   
    AddRevenueFast(){
      const newItem = {
          AccountCode : '',
          AccountValue : '',
          StockCode : '',
          Description : '',
        }
        this.items.push(newItem)
        this.$nextTick(() => {
    setTimeout(() => {
      const inputList = this.$refs.accountCodeInput;
      if (Array.isArray(inputList)) {
        const lastInput = inputList[inputList.length - 1];
        if (lastInput && lastInput.$el && lastInput.$el.focus) {
          lastInput.$el.focus();
        } else if (lastInput && lastInput.focus) {
          lastInput.focus();
        }
      }
    }, 0); // Cho phép Vue thực sự cập nhật ref mới nhất
  });
    },
    DeleteRevenueFast(index){
      if(this.items.length > 1){
        this.items.splice(index, 1);
      }
    },
    async save(){
      if(this.items.some(p => !p.AccountCode || p.AccountCode.trim() === "")) {
        this.showToast('error', this.$t('golf_revenue_fast_error_null'))

        const invalidIndex = this.items.findIndex(p => !p.AccountCode || p.AccountCode.trim() === "");
        this.$nextTick(() => {
        const inputs = this.$refs.accountCodeInput;
          if (Array.isArray(inputs) && inputs[invalidIndex]) {
               const inputEl = inputs[invalidIndex].$el || inputs[invalidIndex];
               if (inputEl.focus) {
                    inputEl.focus();
               }
          }
        });
        return
      }
      if(this.items.some(p => !p.AccountValue || p.AccountValue.trim() === "")) {
        this.showToast('error', this.$t('golf_revenue_fast_value_error_null'))
        this.$nextTick(() => {

        const invalidIndex = this.items.findIndex(p => !p.AccountValue || p.AccountValue.trim() === "");

        const inputs = this.$refs.accountValueInput;
          if (Array.isArray(inputs) && inputs[invalidIndex]) {
               const inputEl = inputs[invalidIndex].$el || inputs[invalidIndex];
               if (inputEl.focus) {
                    inputEl.focus();
               }
          }
        });
        return
      }
      const body = {
        RevenueCenter: {
          Id: this.revenueCenterId,
          RevenueCenterFast: this.items
        }
      } 
       await reportSetting.api_URFA01(body).then(res => {
        this.showResToast(res)
          if(res.Status === '200') {
           this.hideModal()
           this.$emit('event')
          }
      })
    },
    checkAll(data) {
      this.items.forEach(x => {
        x.Checked = data
        x.Members.forEach(y => {
          y.Checked = data
        })
      })
    },
    checkItem(data) {
      this.items.forEach(x => {
        if(x.OpenDate === data.OpenDate) {
          x.Members.forEach(y => {
            y.Checked = data.Checked
          })
        }
      })
    },
    nextForcus(tabindex) {
      jquery('[tabindex="' + (tabindex+1)  + '"]')[0].focus()
    },
    nextForcusDown(tabindex) {
      jquery('[tabindex="' + (tabindex+6)  + '"]')[0].focus()
    },
    nextForcusUp(tabindex) {
      jquery('[tabindex="' + (tabindex-6)  + '"]')[0].focus()
    },
    nextForcusLeft(tabindex) {
      jquery('[tabindex="' + (tabindex-1)  + '"]')[0].focus()
    },
    nextForcusRight(tabindex) {
      jquery('[tabindex="' + (tabindex+1)  + '"]')[0].focus()
    },
  },
}
</script>

<style lang="scss">
#modal-add-revenue-fast {
  // .modal-checkin {
  //       width: calc(100vw*75/100);
  //       max-width: 890px
  // }
  .block-header {
    .title-modal {
      font-style: normal;
      font-weight: 500;
      font-size: 18px;
      line-height: 21px;
    }
  }

  .color-primary {
    color: #114A9F;
  }

  .w-50 {
    width: 65px !important;
  }

  .color-warning {
    color: #FF9F43;
  }

  .content-body-modal {
    font-style: normal;
    font-weight: 500;
    font-size: 14px;
    line-height: 17px;
  }

  .fullname {
    width: 160px;
  }

  .block {

    .dot {
      width: 10px;
      height: 10px;
      border-radius: 100%;
      padding: 0;
    }

    p {
      margin-left: 2px;
      font-weight: 450;
    }
  }
}
</style>
